import React, { useState, useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import { useAuth } from './AuthContext';
import { jwtDecode } from 'jwt-decode';



const MessageInput = ({ message, setMessage }) => {
  const iconToolbox = [
    '😀', '😁', '😎', '🥳', '👏', '🙌', '👍', '💪', '✅', '🔥', '🎯', '🌟', '✨', '🚀',
    '💡', '🎉', '🎬', '🎵', '📷', '📹', '🧠', '📝', '📌', '📣', '💬', '❤️', '🤩'
  ];

  const insertIcon = (icon) => {
    setMessage((prev) => prev + ' ' + icon);
  };

  return (
    <div className="w-100">


      <textarea
        rows={2}
        className="w-100"
        style={{
          width: '100%',
          fontSize: '1rem',
          padding: '1rem',
          border: '1px solid #ccc',
          borderRadius: '8px',
          resize: 'vertical',
          background: '#f9f9f9',
        }}
        value={message}
        onChange={(e) => setMessage(e.target.value)}
        placeholder="Ajoutez un message pour les contributeurs (ex. bravo, prochaine étape, etc.)"
      />
      <div className="flex flex-wrap gap-3 mb-3">
        {iconToolbox.map((icon, idx) => (
          <span
            key={idx}
            onClick={() => insertIcon(icon)}
            className="text-2xl cursor-pointer hover:scale-110 transition-transform"
            style={{ border: 'none', background: 'transparent' }}
          >
            {icon}
          </span>
        ))}
      </div>
    </div>
  );
};
function ProjectContribute() {
  const [showUpload, setShowUpload] = useState(false);
  const { id } = useParams();
  const [media, setMedia] = useState([]);
  const [scenario, setScenario] = useState(null);
  const [messages, setMessages] = useState([]);
  const [userMessage, setUserMessage] = useState('');
  const [activeTab, setActiveTab] = useState('scenario');
  const [file, setFile] = useState(null);
  const [title, setTitle] = useState('');
  const [location, setLocation] = useState('');
  const [description, setDescription] = useState('');
  const scrollContainerRef = useRef(null);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [comment, setComment] = useState('');
  const [selectedTags, setSelectedTags] = useState([]);
  const [customKeyword, setCustomKeyword] = useState('');
  const [hoveredMessageId, setHoveredMessageId] = useState(null);
  const messagesEndRef = useRef(null);
  const [useExistingMedia, setUseExistingMedia] = useState(false);
  const [userMedia, setUserMedia] = useState([]);
  const [selectedMedia, setSelectedMedia] = useState([]);
  const [mediaFilter, setMediaFilter] = useState('');
  const [mediaTypeFilter, setMediaTypeFilter] = useState('');
  const { token } = useAuth();
  const [currentUser, setCurrentUser] = useState({ username: '', name: '', avatar: '' });
  const [username, setUsername] = useState('');

 
  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages]);

  const handleFileUploadClick = () => {
    fileInputRef.current.click();
  };
  const userId = 1; // À adapter dynamiquement si authentification
  const predefinedTags = [
    'culture', 'histoire', 'nature', 'traditions', 'modernité',
    'gastronomie', 'enfance', 'portrait', 'art', 'architecture',
    'ville', 'rural', 'célébration', 'quotidien', 'spiritualité'
  ];
  useEffect(() => {
    if (id) {
      fetch(`/projects/${id}/media`)
        .then(res => res.json())
        .then(setMedia);

      fetch(`/projects/${id}/messages`)
        .then(res => res.json())
        .then(setMessages);
      fetch(`/projects/${id}/scenarios`).then(res => res.json()).then(setScenario);
    }
  }, [id]);
  useEffect(() => {
    if (username) {
      fetch(`/user/${username}/media`)
        .then(res => res.json())
        .then(setUserMedia);
    }
  }, [username]);
  const filteredMedia = userMedia.filter(media => {
    const matchesTitle = media.title?.toLowerCase().includes(mediaFilter);
    const isVideo = media.file_path.match(/\.(mp4|webm|ogg)$/i);
    const matchesType =
      mediaTypeFilter === '' ||
      (mediaTypeFilter === 'video' && isVideo) ||
      (mediaTypeFilter === 'image' && !isVideo);
    return matchesTitle && matchesType;
  });
  useEffect(() => {
    if (!token) return;

    fetch("/media/me", {
      headers: { Authorization: `Bearer ${token}` }
    })
      .then(res => res.json())
      .then(data => {
        if (!Array.isArray(data)) return;
        setUserMedia(data);
      });
  }, [token]);

  function GeocodeAndMarker({ location, description }) {
    const [coords, setCoords] = useState(null);
    const map = useMap();

    useEffect(() => {
      fetch(`https://nominatim.openstreetmap.org/search?q=${encodeURIComponent(location)}&format=json`)
        .then(res => res.json())
        .then(data => {
          if (data[0]) {
            const { lat, lon } = data[0];
            const newCoords = [parseFloat(lat), parseFloat(lon)];
            setCoords(newCoords);
            map.setView(newCoords, 10);
          }
        });
    }, [location, map]);


    return coords ? (
      <Marker position={coords}>
        <Popup>
          <strong>{location}</strong><br />
          {description?.slice(0, 80)}...
        </Popup>
      </Marker>
    ) : null;
  }
useEffect(() => {
  if (!token) return;

  try {
    const decoded = jwtDecode(token);
    const uname = decoded?.preferred_username || '';
    const name = decoded?.name || decoded?.given_name || uname;

    setUsername(uname);
    setCurrentUser({
      username: uname,
      name: name,
      avatar: `https://api.dicebear.com/7.x/initials/svg?seed=${name}`
    });
  } catch (err) {
    console.error('Erreur décodage token :', err);
  }
}, [token]);
  const fileInputRef = useRef(null);

  const handleUploadClick = () => {
    fileInputRef.current?.click();
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      // TODO : Envoie le fichier au backend ici
      alert(`📎 Fichier sélectionné : ${file.name}`);
    }
  };
  const toggleTag = (tag) => {
    if (selectedTags.includes(tag)) {
      setSelectedTags(selectedTags.filter(t => t !== tag));
    } else {
      setSelectedTags([...selectedTags, tag]);
    }
  };

  const addCustomKeyword = () => {
    if (customKeyword.trim()) {
      setSelectedTags([...selectedTags, customKeyword.trim()]);
      setCustomKeyword('');
    }
  };
  const handleScroll = () => {
    const container = scrollContainerRef.current;
    const cardWidth = 240;
    const index = Math.round(container.scrollLeft / cardWidth);
    setCurrentIndex(index);
  };
  const handleFileUpload = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click(); // Trigger the hidden input
    }
  };

  const scroll = (direction) => {
    const container = scrollContainerRef.current;
    const cardWidth = 240;
    container.scrollBy({ left: direction * cardWidth, behavior: 'smooth' });
  };

  const submitMessage = async () => {
    if (!userMessage.trim()) return alert("Merci de saisir un message");

    const res = await fetch(`/projects/${id}/messages`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        user_id: currentUser.username,
        message: userMessage
      })
    });

    const data = await res.json();
    if (data.id) {
      setUserMessage('');
      fetch(`/projects/${id}/messages`)
        .then(res => res.json())
        .then(setMessages);
    }
  };

  const generateCommentWithAI = async () => {
    const prompt = `Génère un scénario immersif et narratif pour un documentaire intitulé "${title}", situé à "${location}". 
Concentre-toi principalement sur la description suivante : "${description}" si elle est renseignée. 
Utilise les mots-clés suivants pour enrichir le ton et l’orientation : ${selectedTags.join(', ')}. 
Le style doit rester captivant, inspirant et à forte valeur culturelle.`;
    try {
      const response = await fetch('/generate-doc', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ title: title, location: location, description: description, tags: selectedTags, prompt })
      });
      const data = await response.json();
      setComment(data.documentary || '');
    } catch (err) {
      console.error('Erreur IA:', err);
      alert("Erreur lors de la génération IA");
    }
  };

  const handleUpload = async () => {
    if (!file || !title || !location || !description) {
      alert("Tous les champs sont obligatoires");
      return;
    }
    const formData = new FormData();
    formData.append('media', file);
    formData.append('title', title);
    formData.append('location', location);
    formData.append('description', description);
    formData.append('project_id', id);
    formData.append('comment', comment);
    const res = await fetch('/linkedMedia', {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`
      },
      body: formData
    });
    const data = await res.json();
    if (data.id) {
      setTitle('');
      setLocation('');
      setDescription('');
      setFile(null);
      setComment('');
      fetch(`/projects/${id}/media`)
        .then(res => res.json())
        .then(data => {
          setMedia(data);
          setActiveTab('media'); // ⬅️ Redirection vers l’onglet Média
        });
    } else {
      alert("❌ Erreur lors de l'ajout du média");
    }
  };


  return (
    <div className="container mt-4" style={{ paddingTop: '70px' }}>
      <h2 className="mb-4">👥 Contribuer au projet {id}</h2>

      <ul className="nav nav-tabs mb-4">
        <li className="nav-item">
          <button className={`nav-link ${activeTab === 'scenario' ? 'active' : ''}`} onClick={() => setActiveTab('scenario')}>📖 Scénario</button>
        </li>
        <li className="nav-item">
          <button className={`nav-link ${activeTab === 'media' ? 'active' : ''}`} onClick={() => setActiveTab('media')}>🎞 Médias</button>
        </li>
        <li className="nav-item">
          <button className={`nav-link ${activeTab === 'upload' ? 'active' : ''}`} onClick={() => setActiveTab('upload')}>📤 Ajouter un média</button>
        </li>
        <li className="nav-item">
          <button className={`nav-link ${activeTab === 'messages' ? 'active' : ''}`} onClick={() => setActiveTab('messages')}>💬 Forum</button>
        </li>
      </ul>
      {activeTab === 'scenario' && scenario && (
        <div className="bg-white p-4 rounded-4 shadow-sm border">
          <h3 className="fw-bold text-primary mb-3 d-flex align-items-center gap-2">
            🎬 {scenario.title}
          </h3>
          <p className="text-muted fs-5 mb-4">{scenario.description}</p>

          <div className="timeline">
            {JSON.parse(scenario.steps || '[]').map((step, index) => (
              <div
                key={index}
                className="timeline-item position-relative ps-4 mb-5 fade-in"
                style={{ transition: 'all 0.4s ease-in-out' }}
              >
                <div className="timeline-dot bg-primary position-absolute top-0 start-0 translate-middle rounded-circle" style={{ width: 16, height: 16 }}></div>

                <div className="bg-light-subtle p-4 rounded-3 shadow-sm border-start border-4 border-primary">
                  <h5 className="mb-2 text-primary d-flex align-items-center gap-2">
                    📍 {step.location}
                  </h5>
                  <p className="text-dark mb-2 fst-italic">{step.description}</p>

                  {step.reference && (
                    <p className="text-muted small mb-2">
                      🔗 <a href={step.reference} target="_blank" rel="noreferrer">Voir la ressource</a>
                    </p>
                  )}

                  <button
                    className="btn btn-outline-primary btn-sm mt-2"
                    onClick={() => {
                      alert(`Tu souhaites contribuer à l’étape "${step.location}" ? Lance-toi depuis l’onglet média 🎥 !`);
                    }}
                  >
                    ✨ Contribuer à cette étape
                  </button>


                </div>
              </div>
            ))}
          </div>
        </div>
      )}


      {activeTab === 'media' && (
        <>
          <h4 className="mb-3">🎬 Bande média du projet</h4>
          {media.length > 0 ? (
            <div className="position-relative">
              <div className="cinema-strip d-flex overflow-auto py-3 px-2 gap-3" ref={scrollContainerRef} onScroll={handleScroll}>
                {media.map((item) => {
                  const isVideo = item.file_path.match(/\.(mp4|webm|ogg)$/i);
                  const mediaUrl = `/${item.file_path}`;
                  return (
                    <div
                      key={item.id}
                      className="media-thumb shadow-sm rounded-4 bg-dark position-relative"
                      style={{ width: '220px', height: '140px', flex: '0 0 auto', overflow: 'hidden', border: '4px solid #222' }}
                      onMouseEnter={(e) => {
                        const video = e.currentTarget.querySelector('video');
                        if (video) {
                          video.currentTime = 0;
                          video.play();
                        }
                      }}
                      onMouseLeave={(e) => {
                        const video = e.currentTarget.querySelector('video');
                        if (video) {
                          video.pause();
                          video.currentTime = 0;
                        }
                      }}
                    >
                      {isVideo ? (
                        <video  src={`/uploads/${mediaUrl}`} className="w-100 h-100 object-fit-cover" playsInline preload="metadata" />
                      ) : (
                        <img  src={`/uploads/${mediaUrl}`} alt={item.title} className="w-100 h-100 object-fit-cover" />
                      )}
                      <div className="position-absolute bottom-0 w-100 text-white text-center bg-black bg-opacity-50 py-1 small">
                        {item.title}
                      </div>
                    </div>
                  );
                })}
              </div>
              <div className="text-center mt-2">
                <span className="badge bg-dark text-light">
                  {currentIndex + 1} / {media.length}
                </span>
              </div>
              <button className="btn btn-dark position-absolute top-50 start-0 translate-middle-y z-1" onClick={() => scroll(-1)}>&lt;</button>
              <button className="btn btn-dark position-absolute top-50 end-0 translate-middle-y z-1" onClick={() => scroll(1)}>&gt;</button>
            </div>
          ) : (
            <div className="alert alert-info text-center rounded-4 p-4 shadow-sm">
              🎉 <strong>T’es le premier contributeur !</strong><br />Ajoute un média pour démarrer cette aventure documentaire 🚀
            </div>
          )}
        </>
      )}


      {activeTab === 'upload' && (
        <div className="bg-white p-4 rounded-4 shadow-lg border border-3 border-primary-subtle">
          <div className="d-flex justify-content-between align-items-center mb-4">
            <h4 className="text-primary mb-0">📤 Ajouter un média</h4>
            <div className="form-check form-switch">
              <input
                className="form-check-input"
                type="checkbox"
                checked={useExistingMedia}
                onChange={() => {
                  setUseExistingMedia(!useExistingMedia);
                  setSelectedMedia([]);
                }}
                id="toggleExistingMedia"
              />
              <label className="form-check-label ms-2" htmlFor="toggleExistingMedia">
                Utiliser un média existant
              </label>
            </div>
          </div>

          {!useExistingMedia ? (
            <>
              <div className="row">
                <div className="col-md-6 mb-3">
                  <label className="form-label fw-bold">🎬 Titre du média</label>
                  <input className="form-control form-control-lg" value={title} onChange={e => setTitle(e.target.value)} />
                </div>
                <div className="col-md-6 mb-3">
                  <label className="form-label fw-bold">📍 Localisation</label>
                  <input className="form-control form-control-lg" value={location} onChange={e => setLocation(e.target.value)} />
                </div>
              </div>
              <div className="row">
                <div className="col-md-12 mb-3">
                  <label className="form-label fw-bold">📝 Description</label>
                  <input className="form-control form-control-lg" value={description} onChange={e => setDescription(e.target.value)} />
                </div>
              </div>
              <div className="mb-3">
                <label className="form-label fw-bold">🖼️ Fichier média</label>
                <input type="file" className="form-control form-control-lg" onChange={e => setFile(e.target.files[0])} />
              </div>
              <div className="mb-3">
                <label className="form-label fw-bold">💬 Commentaire IA (optionnel)</label>
                <div className="mb-2">
                  <label className="form-label">🏷️ Thèmes</label>
                  <div className="d-flex flex-wrap gap-2">
                    {predefinedTags.map(tag => (
                      <button
                        key={tag}
                        onClick={() => toggleTag(tag)}
                        className={`tag-chip border-0 px-3 py-2 rounded-pill fw-medium ${selectedTags.includes(tag) ? 'bg-gradient text-white shadow-sm' : 'bg-light text-dark border'}`}
                        style={{ transition: 'all 0.2s ease-in-out', cursor: 'pointer', border: '1px solid #ccc' }}
                      >
                        {selectedTags.includes(tag) ? '✅ ' : '➕ '} {tag}
                      </button>
                    ))}
                  </div>
                </div>
                <button className="btn btn-outline-dark btn-sm mb-2" onClick={generateCommentWithAI}>🤖 Générer automatiquement</button>
                <textarea
                  className="form-control"
                  rows="3"
                  placeholder="Décrivez votre média ou laissez l’IA proposer une description..."
                  value={comment}
                  onChange={e => setComment(e.target.value)}
                />
              </div>
              <div className="text-center mt-4">
                <button className="btn btn-success btn-lg px-5" onClick={handleUpload}>✅ Ajouter ce média au projet</button>
              </div>
            </>
          ) : (
            <>
              <div className="mb-3 row">
                <div className="col-md-6">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="🔍 Filtrer par titre..."
                    onChange={e => setMediaFilter(e.target.value.toLowerCase())}
                  />
                </div>
                <div className="col-md-6">
                  <select
                    className="form-select"
                    onChange={e => setMediaTypeFilter(e.target.value)}
                    defaultValue=""
                  >
                    <option value="">🎞️ Tous les formats</option>
                    <option value="image">🖼️ Images</option>
                    <option value="video">🎬 Vidéos</option>
                  </select>
                </div>
              </div>

              {filteredMedia.length > 0 ? (
                <>
                  <div className="row row-cols-1 row-cols-sm-2 row-cols-md-4 g-3">
                    {filteredMedia.map(media => {
                      const isVideo = media.file_path.match(/\.(mp4|webm|ogg)$/i);
                      const mediaUrl = `/uploads/${media.file_path}`;
                      const isSelected = selectedMedia.includes(media.id);

                      return (
                        <div className="col" key={media.id}>
                          <div
                            className={`card shadow-sm h-100 ${isSelected ? 'border-success border-3' : ''}`}
                            style={{ cursor: 'pointer' }}
                            onClick={() => {
                              setSelectedMedia(prev =>
                                prev.includes(media.id)
                                  ? prev.filter(id => id !== media.id)
                                  : [...prev, media.id]
                              );
                            }}
                          >
                            {isVideo ? (
                              <video  src={`${mediaUrl}`} className="card-img-top" muted />
                            ) : (
                              <img  src={`${mediaUrl}`} className="card-img-top" alt={media.title} />
                            )}
                            <div className="card-body p-2 text-center">
                              <p className="card-title small mb-0">{media.title}</p>
                              {isSelected && <p className="text-success small">✅ Sélectionné</p>}
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>

                  <div className="text-center mt-4">
                    <button
                      className="btn btn-success btn-lg px-5"
                      onClick={async () => {
                        const res = await fetch(`/linkedMedia/existing`, {
                          method: 'POST',
                          headers: {
                            'Content-Type': 'application/json',
                            Authorization: `Bearer ${token}`
                          },
                          body: JSON.stringify({
                            media_ids: selectedMedia,
                            project_id: id
                          })
                        });

                        const data = await res.json();

                        if (data.success) {
                          // Recharge les médias du projet
                          fetch(`/projects/${id}/media`)
                            .then(res => res.json())
                            .then(data => {
                              setMedia(data);
                              setActiveTab('media');
                            });

                        } else {
                          alert("❌ Erreur lors de l’ajout du média (mauvais ID ?)");
                        }
                      }}

                    >
                      Ajouter les médias sélectionnés au projet
                    </button>
                  </div>
                </>
              ) : (
                <div className="alert alert-info">Aucun média trouvé pour cet utilisateur</div>
              )}
            </>
          )}
        </div>
      )}




      {activeTab === 'messages' && (
  <div className="chat-wrapper container p-0">
    <h5 className="my-3">💬 Forum du documentaire</h5>

    <div className="bg-light rounded-4 p-3 mb-4">
      {messages.map((msg, idx) => (
        <div key={idx} className="border rounded-3 p-3 mb-3">
          <div className="d-flex justify-content-between align-items-center mb-1">
            <div className="d-flex align-items-center gap-2">
              <img
  src={msg.avatar_url ? `${msg.avatar_url}` : `https://api.dicebear.com/7.x/initials/svg?seed=${msg.user_id}`}
  alt={msg.user_id}
  className="rounded-circle"
  style={{ width: '32px', height: '32px', objectFit: 'cover' }}
/>
              <strong>{msg.user_id}</strong>
            </div>
            <small className="text-muted">
              🕒 {new Date(msg.created_at).toLocaleString('fr-FR')}
            </small>
          </div>
          <div>{msg.message}</div>
        </div>
      ))}
    </div>

    <div className="mt-3">
      <MessageInput message={userMessage} setMessage={setUserMessage} />
      <button className="btn btn-primary mt-2" onClick={submitMessage}>
        📤 Envoyer
      </button>
    </div>
  </div>
)}









    </div>
  );
}

export default ProjectContribute;
